import * as amplitude from '@amplitude/analytics-browser';
import { webConfig } from '@blockit/web-shared/config/webConfig';
import { redactPathIdsPlugin } from '@features/analytics/utils/redactPathIdsPlugin';
import { shouldRecordSessionReplay } from '@features/analytics/utils/shouldRecordSessionReplay';

/**
 * Init itself stays at boot: attribution and the first page view read the landing URL, which the
 * router's redirects can rewrite (dropping UTM params) moments later. Session replay only needs to
 * start recording, so its plugin loads as a separate chunk instead of riding in the entry.
 */
export const initAmplitude = () => {
  const apiKey = webConfig.amplitudeApiKey;
  if (!apiKey) {
    return;
  }
  amplitude.add(redactPathIdsPlugin());
  amplitude.init(apiKey, undefined, {
    defaultTracking: { sessions: true, pageViews: true, formInteractions: true, fileDownloads: true },
    logLevel: amplitude.Types.LogLevel.Warn,
  });
  if (shouldRecordSessionReplay(window.location.pathname)) {
    void import('@amplitude/plugin-session-replay-browser').then(({ sessionReplayPlugin }) =>
      // TODO - reevaluate and adjust sample rate if this volume is too high
      amplitude.add(sessionReplayPlugin({ forceSessionTracking: true, sampleRate: 1.0 })),
    );
  }
};
